// extracted by mini-css-extract-plugin
export default {"infoBar":"InfoBar_infoBar__LHWuH","infoBarText":"InfoBar_infoBarText__72fCC"};